declare global {
  interface Window {
    fcWidget: {
      setTags: (tags: string[]) => void
      isOpen: () => boolean
      open: () => void
      on: (name: string, func: Function) => void
      init: ({}: any) => void
      destroy: () => void
      user: {
        update: ({}: any) => void
      }
    }
  }
}

declare global {
  interface Window {
    clarity: (event: string, ...args: string[]) => Promise<any>
  }
}

export enum FreshChatTags {
  support = '#chatwithsupport',
  hideAccount = 'deactivation',
  deleteAccount = 'deletion',
  declinedPayment = 'declined_payment',
  cancelGift = 'cancel_gift'
}
